import { Alert, Box } from 'app/components/design-system-components'
import theme from 'app/match/applicationReportPDF/assets/theme'
import { RENTER_BGC_ELIGIBILITY_ALERT_TEXT } from 'app/utils/text/helpers'

export const BGC_PAY_ALERT_NSW_SA = (
  <Box
    fontSize={theme.fontSizes.pRegular14}
    lineHeight={theme.lineHeights.encrption}
  >
    *NOTE: <>{RENTER_BGC_ELIGIBILITY_ALERT_TEXT}</>.{' '}
    <a
      href="https://help.snug.com/hc/en-us/articles/11848299704335-Why-is-a-Background-Check-not-available-in-my-State"
      target="blank"
    >
      learn more
    </a>
  </Box>
)

function RenterBGCEligbilityAlert() {
  return (
    <Alert leftIconVariant="info" showLeftIcon={true} variant="blueWithBg">
      {BGC_PAY_ALERT_NSW_SA}
    </Alert>
  )
}

export default RenterBGCEligbilityAlert
